// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2Fb1N","errors":"Errors_errors__2DRP2"};